export const languageConfigs = [
  { name: 'English', key: 'en-GB' },
  { name: 'Spanish', key: 'sp' },
  { name: 'Hindi', key: 'hi' },
  { name: 'Telugu', key: 'te' }
]